import React, { Component } from 'react';
import { markdownToHtml } from '$lib/markdown';
import QuizGenericChoices from '../QuizGenericChoices';
import styles from './styles.scss';

class QuizQuantityComparison extends Component {
  render() {
    const { handleChoice, quizObj, quizState } = this.props;
    const { quiz } = quizObj;
    const { prompt, seed } = quiz;
    const { given, a, b } = prompt;

    return (
      <div className={styles.layout}>
        <div className={styles.prompt}>
          <div className={styles.given}>{markdownToHtml(given)}</div>
          <div className={styles.quantities}>
            <div className={styles.quantityA}>
              <div className={styles.quantityTitle}>Quantity A</div>
              <div className={styles.quantityMarkdown}>{markdownToHtml(a)}</div>
            </div>
            <div className={styles.quantityB}>
              <div className={styles.quantityTitle}>Quantity B</div>
              <div className={styles.quantityMarkdown}>{markdownToHtml(b)}</div>
            </div>
          </div>
        </div>
        <QuizGenericChoices
          key={seed}
          handleChoice={handleChoice}
          quizState={quizState}
          quizObj={quizObj}
        />
      </div>
    );
  }
}

export default QuizQuantityComparison;
